/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authSelectOrganisation } from '../../axios/authSelectOrganisation'
import type {
	AuthSelectOrganisationError,
	AuthSelectOrganisationRequest,
	AuthSelectOrganisationResponse,
} from '../../types/AuthSelectOrganisation'

export const authSelectOrganisationMutationKey = () => [{ url: '/auth/select-organisation' }] as const

export type AuthSelectOrganisationMutationKey = ReturnType<typeof authSelectOrganisationMutationKey>

export type AuthSelectOrganisationVariables = {
	data: AuthSelectOrganisationRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::selectOrganisation */
export function useAuthSelectOrganisation<TContext = unknown>(
	options?: UseMutationOptions<
		AuthSelectOrganisationResponse,
		AxiosError<AuthSelectOrganisationError>,
		AuthSelectOrganisationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authSelectOrganisationMutationKey(),
		mutationFn: ({ data }: AuthSelectOrganisationVariables) =>
			authSelectOrganisation(data, config).then(res => res.data),
		...options,
	})
}
